module.exports = __webpack_public_path__ + "img/hito003.4b7717fa.webp";